module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 202
// module chunks = 0